import { word } from "@modules/core/utils/i18n"
import { ProgramBundleSubscriberEntity } from "@modules/programBundle/programBundleSubscribers/entities/programBundleSubscriberEntity"
import { ProgramSubscriberDetailsContentOnOffPrice } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsContentOnOffPrice"
import { ProgramSubscriberDetailsContentOnOffStatus } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsContentOnOffStatus"
import { ProgramSubscriberDetailsContentPrice } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsContentPrice"
import { ProgramSubscriberDetailsContentStatus } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsContentStatus"
import { ProgramSubscriberDetailsMenu } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsMenu"
import { ProgramSubscriberDetailsViewTabs } from "@modules/programs/programSubscriber/entities/programSubsciberType"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

type ProgramSubscriberDetailsContentProps = {
  subscriberDetails: ProgramSubscriberEntity | ProgramBundleSubscriberEntity
  setActiveTab: (tab: ProgramSubscriberDetailsViewTabs) => void
  programId: string
  className?: string
} & React.ComponentProps<"div">

export function ProgramSubscriberDetailsContent({
  subscriberDetails,
  setActiveTab,
  programId,
  className,
  ...props
}: ProgramSubscriberDetailsContentProps) {
  const defautlClassName = "card flex flex-column gap-4 mb-6 p-0 px-4 py-3 w-full"
  const theme = useTheme()

  return (
    <div className={className ?? defautlClassName} {...props}>
      {/* STATUS */}
      {subscriberDetails instanceof ProgramSubscriberEntity && subscriberDetails.onOffProgramProgression ? (
        <ProgramSubscriberDetailsContentOnOffStatus subscriberDetails={subscriberDetails} />
      ) : (
        <ProgramSubscriberDetailsContentStatus subscriberDetails={subscriberDetails} />
      )}

      {/* PRICE */}
      {subscriberDetails instanceof ProgramSubscriberEntity && subscriberDetails.onOffProgramProgression ? (
        <ProgramSubscriberDetailsContentOnOffPrice subscriberDetails={subscriberDetails} />
      ) : (
        <ProgramSubscriberDetailsContentPrice subscriberDetails={subscriberDetails} />
      )}

      {/* INTERNAL NOTE */}
      <div className="flex flex-column gap-2 w-full">
        <div className="flex w-full gap-2 align-items-baseline">
          <HUText fontStyle="BS" color={theme.neutralColor700}>
            {word("program.subscribers.subscriptionDetails.internalNote.title")}
          </HUText>
          <div className="flex flex-grow-1 border-top-1 border-neutralColor-300" />
        </div>
        <HUText fontStyle="BM" color={theme.neutralColor900}>
          {subscriberDetails.internalNote && subscriberDetails.internalNote !== ""
            ? subscriberDetails.internalNote
            : word("program.subscribers.subscriptionDetails.internalNote.none")}
        </HUText>
      </div>

      <div className="flex justify-content-end gap-2 w-full">
        <ProgramSubscriberDetailsMenu
          subscriberDetails={subscriberDetails}
          setActiveTab={setActiveTab}
          programId={programId}
        />
      </div>
    </div>
  )
}
